"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserAgent = void 0;
const isUserAgent = (match) => Boolean(window.navigator.userAgent.match(match));
exports.isUserAgent = isUserAgent;
